import React from 'react';
import styled from 'styled-components';
import { ContributionDetailsProps } from './ContributionDetails';

type ContributionDatesProps = ContributionDetailsProps

const StyledDiv = styled.div``;

const ContributionDates: React.FC<ContributionDatesProps> = ({ className }) => {
  return <StyledDiv className={className}>Contribution Dates</StyledDiv>;
};

export default ContributionDates;
